import { render, staticRenderFns } from "./MenuTitle.vue?vue&type=template&id=ab6b088a&scoped=true&"
import script from "./MenuTitle.vue?vue&type=script&lang=js&"
export * from "./MenuTitle.vue?vue&type=script&lang=js&"
import style0 from "./MenuTitle.vue?vue&type=style&index=0&id=ab6b088a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab6b088a",
  null
  
)

export default component.exports